<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconInfoTip',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-info-tip', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path d="M12 2.192c1.019 0 2.017.155 2.97.457a.642.642 0 0 1-.389 1.224 8.525 8.525 0 1 0 2.504 1.285.642.642 0 1 1 .767-1.03A9.8 9.8 0 0 1 21.808 12c0 5.417-4.391 9.808-9.808 9.808S2.192 17.417 2.192 12 6.583 2.192 12 2.192m0 6.6c.348 0 .636.258.681.594l.007.093v7.334a.687.687 0 0 1-1.37.093l-.005-.093V9.479c0-.38.307-.687.687-.687m0-2.521a.917.917 0 1 1 0 1.833.917.917 0 0 1 0-1.833"/>
    </template>
  </svg>
</template>